import { useCurrentLang, useTranslator, useTransliterateName } from '$hooks';
import * as incline from 'petrovich';
import { GroupModel, UserModel } from '$store/models';
import { useMemo } from 'react';

export type InclineCase =
  | 'nominative'
  | 'genitive'
  | 'dative'
  | 'accusative'
  | 'instrumental'
  | 'prepositional';

export const useUnitName = (
  unit: UserModel | GroupModel,
  inclineCase?: InclineCase | null,
  namePart?: 'firstName' | 'lastName' | 'short',
) => {
  const { key } = useCurrentLang();
  const t = useTranslator();

  const getUserName = (nameData: { firstName: string; lastName: string }) => {
    if (namePart && namePart != 'short') {
      return nameData[namePart];
    } else if (namePart === 'short') {
      return `${nameData.firstName} ${nameData.lastName.substring(0, 1)}`;
    }

    return `${nameData.firstName}${nameData.lastName.length >= 1 ? ' ' : ''}${
      nameData.lastName
    }`;
  };

  const fullName = useMemo(() => {
    let result = unit
      ? 'name' in unit
        ? unit.name
        : getUserName({ firstName: unit.firstName, lastName: unit.lastName })
      : '';

    if (unit && inclineCase && 'firstName' in unit && key === 'ru') {
      let currentSex = 'androgynous';

      if (unit.sex === 1) {
        currentSex = 'female';
      } else if (unit.sex === 2) {
        currentSex = 'male';
      }

      const { first, last } = incline(
        {
          gender: currentSex,
          first: unit.firstName || '',
          last: unit.lastName || '',
        },
        inclineCase,
      );

      result = getUserName({
        firstName: first,
        lastName: last,
      });
    }

    return result;
  }, [unit, inclineCase, key, namePart]);

  const result = useTransliterateName(fullName);
  return unit?.isBanned ? t('banned_first_name') : result;
};
